import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";

export const SizeButton = styled.button<{
  variant: "unselected" | "selected" | "unavailable";
  disabled?: boolean;
}>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  border: none;
  transition: all 0.2s ease;
  position: relative;

  ${(props) => {
    switch (props.variant) {
      case "unselected":
        return `
        background-color: ${colorPalette.popWhite[500]};
        border: 1px solid ${colorPalette.popBlack[500]};
        `;
      case "selected":
        return `
          background-color: ${colorPalette.success[500]};
        `;
      case "unavailable":
        return `
          background-color: ${colorPalette.popWhite[500]};
          border: 1px solid ${colorPalette.popBlack[100]};
          color: ${colorPalette.popBlack[100]};
          
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 1px;
            height: 48px;
            background-color: ${colorPalette.popBlack[100]};
            transform: translate(-50%, -50%) rotate(45deg);
          }
        `;
      default:
        return "";
    }
  }}
`;
